import React from "react";
import { MdOutlineAdd } from "react-icons/md";
import { BsArrowUpRight } from "react-icons/bs";
import ButtonSpinner from "../Loader/ButtonSpinner";
import { cn } from "../ui-x";

type Props = {
  label?: string;
  className?: string;
  onClick?: (e?: any) => void;
  type?: "button" | "submit" | "reset" | undefined;
  icon?: string;
  disabled?: boolean;
  loading?: boolean;
};

export const renderButtonIcon = (icon?: string) => {
  if (icon === "add") return <MdOutlineAdd className="h-4 w-4" />;
  if (icon === "arrow-upright") return <BsArrowUpRight className="h-4 w-4" />;
  return null;
};

/**
 * Button chassis, sized to the reference (h-9 / px-4 / rounded-lg). Colour is
 * still supplied by the call site's className — the reference allows exactly
 * one orange button per screen, so that choice belongs to the page.
 */
const Button = ({
  label,
  className,
  onClick,
  type,
  icon,
  disabled,
  loading,
}: Props) => {
  const onClickHandler = (e: any) => {
    if (typeof onClick === "function") {
      e.preventDefault();
      onClick && onClick();
    }
  };

  return (
    <div>
      <button
        type={type}
        disabled={disabled}
        className={cn(
          "flex h-9 flex-row items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-transparent px-4 text-sm font-semibold transition-colors hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        onClick={onClickHandler}
      >
        {label}
        {renderButtonIcon(icon)}
        {loading && <ButtonSpinner />}
      </button>
    </div>
  );
};

export default Button;
